import React, { useState } from 'react';

import { Point } from './header/header.types';
import { Nullable } from '../../types/common';
import ProductAttributeSetPoints from './ProductAttributeSetPoints';

import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
// eslint-disable-next-line import/no-named-default
import { default as styles } from '../../scss/components/ProductAttributeSet.module.scss';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

interface ProductAttributeSetProps {
  header: string;
  points?: Point[];
}

const ProductAttributeSet = ({ header, points }: ProductAttributeSetProps) => {
  const [elementOpen, setElementOpen] = useState(false);
  const [selectedIcon, setSelectedIcon] = useState<Nullable<number>>(null);

  const handleOpen = (index: number) => {
    setSelectedIcon(index);
    setElementOpen(true);
  };

  const handleClose = () => {
    setSelectedIcon(null);
    setElementOpen(false);
  };

  const collapsedPoints = points?.map((point, index) => (
    <ProductAttributeSetPoints
      key={index}
      type="collapsed-points"
      point={point}
      index={index}
      selectedIcon={selectedIcon}
      handleOpen={handleOpen}
    />
  ));

  const expandedPoints = points?.map((point, index) => (
    <ProductAttributeSetPoints
      key={index}
      type="expanded-points"
      point={point}
      index={index}
      selectedIcon={selectedIcon}
      handleOpen={handleOpen}
    />
  ));

  const expandLink = (
    <div
      className={withCssModulesClassNamesHandler('expand-link-container')}
      data-testid="expand-link"
    >
      <div
        className={withCssModulesClassNamesHandler('expand-link')}
        onClick={() => setElementOpen(true)}
      >
        See upholstery details
      </div>
    </div>
  );

  const collapseButton = (
    <div
      aria-label="Close"
      data-testid="collapse-button"
      className={withCssModulesClassNamesHandler('collapse-button')}
      role="button"
      onClick={() => handleClose()}
    >
    <i className="icon icon-close-product-attribute-sets" />
  </div>
  );

  return (
    <div className={withCssModulesClassNamesHandler('parent-container')}>
      <div className={withCssModulesClassNamesHandler('header-section')}>
        <h2 className={withCssModulesClassNamesHandler('header')}>{header}</h2>
        <div className={withCssModulesClassNamesHandler(elementOpen ? 'visible-element' : 'hidden-element')}>
          {elementOpen && collapseButton}
        </div>
      </div>
      <div className={withCssModulesClassNamesHandler('container')}>
        <div className={withCssModulesClassNamesHandler('collapsed-container', !elementOpen ? 'visible-element' : 'hidden-element')}>
          {!elementOpen && collapsedPoints}
          {!elementOpen && expandLink}
        </div>
        <div className={withCssModulesClassNamesHandler('expanded-container', elementOpen ? 'visible-element' : 'hidden-element')}>
          {elementOpen && expandedPoints}
        </div>
      </div>
    </div>
  );
};

ProductAttributeSet.defaultProps = {
  header: 'Please add a header to this component',
};

export default ProductAttributeSet;
